import React, { Component } from 'react';
import { withRouter } from '../withRouter.js';
import api from '../services/api.js';
import apiString from '../services/apiString.js';
import apiStringServer from '../services/apiStringServer.js';
import apiMunicipios from '../services/apiMunicipios.js';

import axios from 'axios';

import theme from './themes/Theme';
import { ThemeProvider } from '@mui/material';

import { Map, GoogleApiWrapper, Marker, InfoWindow, Polygon } from 'google-maps-react';
import { setKey, setLanguage, fromLatLng, fromAddress } from "react-geocode";

import yellow_marker from '../assets/yellow_marker.png';
import green_marker from '../assets/green_marker.png';
import red_marker from '../assets/red_marker.png';
import school_icon from '../assets/map_icons/school_icon.png';
import police_icon from '../assets/map_icons/police_icon.png';
import fire_icon from '../assets/map_icons/fire_icon.png';
import healthcare_icon from '../assets/map_icons/healthcare_icon.png';
import water_treatment_icon from '../assets/map_icons/water_treatment_icon.png';
import reservoirs_icon from '../assets/map_icons/reservoirs_icon.png';
import train_icon from '../assets/map_icons/train_icon.png';
import jails_icon from '../assets/map_icons/jails_icon.png';

/*import escolas_2022 from './utils/escolas_2022.json';
import batalhoes_policia_militar from './utils/batalhoes_policia_militar.json';
import batalhoes_corpo_bombeiros_militares from './utils/batalhoes_corpo_bombeiros_militares.json';
import estabelecimentos_de_saude from './utils/estabelecimentos_de_saude.json';
import estacoes_tratamento_agua from './utils/estacoes_tratamento_agua.json';
import reservatorios from './utils/reservatorios.json';
import estacoes_trem from './utils/estacoes_trem.json';
import trajetos_trem from './utils/trajetos_trem.json';
import preservacao_permanente_nascentes from './utils/preservacao_permanente_nascentes.json';
import suscetibilidade_enxurrada from './utils/suscetibilidade_enxurrada.json';
import areas_pragmaticas_saude from './utils/areas_pragmaticas_saude.json';
import coordenadorias_regionais_educacao from './utils/coordenadorias_regionais_educacao.json';
import areas_protegidas from './utils/areas_protegidas.json';
import unidades_prisionais from './utils/unidades_prisionais.json';
import hidrografia from './utils/hidrografia.json';*/
//import regioes_saude_estadual from './utils/regioes_saude_estadual.json'; //usar a solução de dividir o arquivo em 2 ou mais

//import map_Rio from '../assets/citities/map_Rio.png';

import polygonCoords_Rio from './utils/polygonRio';
import polygonCoords_Rio1 from './utils/polygonRio1';
import polygonCoords_Rio2 from './utils/polygonRio2';
import polygonCoords_Rio21 from './utils/polygonRio21';
import polygonCoords_Rio3 from './utils/polygonRio3';
import polygonCoords_Rio31 from './utils/polygonRio31';

import Header from '../components/Header.js';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Search from '@mui/icons-material/Search';
import Visibility from '@mui/icons-material/Visibility';
//import Table from '../components/Table.js';
import Button from '@mui/material/Button';
//import ResponsiveContainer from '@bit/recharts.recharts.responsive-container';
import Container from '@mui/material/Container';
import FooterHome from '../components/FooterHome.js';

import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { ptBR } from '@mui/x-data-grid/locales';
import Edit from '@mui/icons-material/Edit';
import Assignment from '@mui/icons-material/Assignment';
import Share from '@mui/icons-material/Share';
import Delete from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import Fab from '@mui/material/Fab';
import Close from '@mui/icons-material/Close';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import { WindowSharp } from '@mui/icons-material';

const anotherItems = ['Tema', 'Sub-Tema', 'Nome', 'Nº de Referência', 'Secretaria', 'Descrição', 'Status'];

let columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'name',
    headerName: 'Nome',
    width: 150,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Nome '}
        <span role="img" aria-label="enjoy">
          🔤
        </span>
      </strong>
    ),
  },
  {
    field: 'process',
    headerName: 'Nº de Referência',
    width: 170,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Nº de Referência'}
        <span role="img" aria-label="enjoy">
          ♎
        </span>
      </strong>
    ),
  },
  {
    field: 'protocol',
    headerName: 'Protocolo',
    width: 150,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Protocolo '}
        <span role="img" aria-label="enjoy">
          📄
        </span>
      </strong>
    ),
  },
  {
    field: 'secretary',
    headerName: 'Secretaria',
    width: 250,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Secretaria '}
        <span role="img" aria-label="enjoy">
          🏛️
        </span>
      </strong>
    ),
  },
  {
    field: 'subcategory',
    headerName: 'Subcategoria',
    width: 330,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Subcategoria '}
        <span role="img" aria-label="enjoy">
          🏷️
        </span>
      </strong>
    ),
  },
  {
    field: 'city',
    headerName: 'Cidade',
    width: 200,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Cidade '}
        <span role="img" aria-label="enjoy">
          🏙️
        </span>
      </strong>
    ),
  },
  {
    field: 'theme',
    headerName: 'Tema',
    width: 200,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Tema '}
        <span role="img" aria-label="enjoy">
          📢
        </span>
      </strong>
    ),
  },
  {
    field: 'subtheme',
    headerName: 'Sub-Tema',
    width: 200,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Sub-Tema '}
        <span role="img" aria-label="enjoy">
          📣
        </span>
      </strong>
    ),
  },
  {
    field: 'description',
    headerName: 'Descrição',
    width: 200,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Descrição '}
        <span role="img" aria-label="enjoy">
          🗨️
        </span>
      </strong>
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 130,
    editable: false,
    renderHeader: () => (
      <strong>
        {'Status '}
        <span role="img" aria-label="enjoy">
          ✔️
        </span>
      </strong>
    ),
  },
  {
    field: 'actions',
    headerName: 'Ações',
    renderCell: () => (
      <Actions />
    ),
    sortable: false,
    width: 100,
    headerAlign: 'center',
    filterable: false,
    align: 'center',
    disableColumnMenu: true,
    disableReorder: true,
  },
];

let rows = [];

let rowsArray = [];

let process = '';
let user = '';

let selected_city = 'rj';

setKey("AIzaSyCxR8BvJtPbkL9EsQ-j-Fze8DaDTpFlGnk");
setLanguage("pt-BR");

//const apiNewsKey = 'cb783d3e76dc4334972b22a110e5014f';

export class Actions extends Component {

  state = {
    openDialog: false,
    status: '1',
    copied: false,

    page_rows: [],
  }

  handleSee = async () => {

    setTimeout(() => {
      window.open(`${apiString}/process?process_id=${process}&user=${user}&selected_city=${selected_city}`, '_blank'); //enviar selected_city para process
    }, 1500);

  }

  handleShare = async () => {

    this.setState({ copied: true });

  }

  handleEdit = async () => {
    await this.setState({ openDialog: true });
    //let 
    //alert(JSON.stringify(rowsArray[0]));
  }

  handleDelete = async () => {

  }

  onStatusChange = async () => {

    try {
      let resp = await api.get('/updateprocess', {
        params: {
          process_id: process,
          status: this.state.status,
          selected_city: 'rj'
        }
      });
      if (resp != null) {
        if (resp.data) {
          if (JSON.stringify(resp.data).includes('edited')) {

            window.location.reload();

          } else {
            let msg = JSON.stringify(resp.data);
            console.log(msg);
          }
        }
      }
    } catch (err) {
      alert('Não foi possível buscar os dados do usuário. ' + err);
    }
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    return (
      <div style={styles.html}>
        <ThemeProvider theme={theme}>
          <IconButton
            color="inherit"
            size="small"
            aria-label="see"
            onClick={this.handleSee}
          >
            <Visibility fontSize="small" />
          </IconButton>

          <CopyToClipboard text={`${apiString}/process?process_id=${process}&user=${user}&selected_city=${selected_city}`}>
            <IconButton
              color="inherit"
              size="small"
              aria-label="share"
              onClick={this.handleShare}
            >
              <Share fontSize="small" />
            </IconButton>
          </CopyToClipboard>

          <IconButton
            color="inherit"
            size="small"
            aria-label="edit"
            onClick={this.handleEdit}
          >
            <Edit fontSize="small" />
          </IconButton>
          <IconButton
            color="inherit"
            size="small"
            aria-label="delete"
            onClick={this.handleDelete}
          >
            <Delete fontSize="small" />
          </IconButton>

          <Dialog open={this.state.openDialog} onClose={() => this.setState({ openDialog: false })}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Alteração</DialogTitle>
            <DialogContent>
              <DialogContentText color="#323232">
                Selecione ou preencha os campos que deseja alterar.
              </DialogContentText>

              <FormControl variant="outlined" fullWidth style={{ marginBottom: 20 }}>
                <InputLabel htmlFor="outlined-theme-native-simple">
                  Status
                </InputLabel>
                <Select
                  autoFocus
                  native
                  value={this.state.status}
                  onChange={this.handleChange}
                  label="Status"
                  inputProps={{
                    name: 'status',
                    id: 'outlined-status-native-simple',
                  }}
                >
                  <option value="1">Pendente</option>
                  <option value="2">Regularizado</option>
                  <option value="3">Negado</option>
                </Select>
              </FormControl>

            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.setState({ openDialog: false })} style={{ color: '#d9be29' }}>
                Cancelar
              </Button>
              <Button onClick={async () => {
                this.setState({ openDialog: false });
                this.onStatusChange();
              }} style={{ color: '#d9be29' }}>
                Alterar
              </Button>
            </DialogActions>
          </Dialog>
        </ThemeProvider>
      </div>
    );
  }
}

let users = [];

export class HomeRio extends Component {

  state = {
    user_id: '',
    login: '',
    option: '',
    selected_city: '',
    secretary: '',
    secretary_id: '',

    process_id: '',
    protocol: '',
    subcategory: '',

    zoom: 10,
    mobilezoom: 10,
    latitude: '',
    longitude: '',
    showingInfoWindow: false,
    showingInfoWindow2: false,
    activeMarker: {},
    selectedPlace: {},

    places: [],

    cpf_cnpj: '',
    name: '',
    email: '',
    street: '',
    number: '',
    district: '',
    city: '',
    state: '',

    new_lat: '',
    new_lng: '',

    expanded: false,
    openDialog: false,

    renderTable: false,

    url: null,

    search: '',

    polygonCoords_RioGeral: [],

    page_rows: [],

    row: true,

    adminDocs: false,
    defenseDocs: false,
    humanDocs: false,
    childDocs: false,
    cutureDocs: false,
    servicesDocs: false,
    newsDocs: false,

    processView: false,
    renderProcess: false,

    oneSearch: '',
    oneMarker: null,

    polygonCoords_RioGeral: [],

    filterView: false,

    iframeUrl: '',
    news: [],
    newsClicked: false,

    schools: false,
    schools_2022Data: [],

    militaryPolices: false,
    militaryPolicesData: [],

    fireDepartment: false,
    fireDepartmentData: [],

    healthcare: false,
    healthcareData: [],

    waterTreatment: false,
    waterTreatmentData: [],

    reservoirs: false,
    reservoirsData: [],

    train: false,
    trainData: [],

    trainWays: false,
    trainWaysData: [],

    springPreservation: false,
    springPreservationData: [],

    flashFloodsSusceptibility: false,
    flashFloodsSusceptibilityData: [],

    healthcarePragmaticAreas: false,
    healthcarePragmaticAreasData: [],

    educationCoordnators: false,
    educationCoordnatorsData: [],

    protectedAreas: false,
    protectedAreasData: [],

    jails: false,
    jailsData: [],

    hydrography: false,
    hydrographyData: [],

    no_entidade: '',
    end_concat: '',

    no_fantasia: '',
    ds_endereco: '',
  }

  async componentDidMount() {

    this.state.polygonCoords_RioGeral = polygonCoords_Rio.concat(polygonCoords_Rio1);
    this.state.polygonCoords_RioGeral = this.state.polygonCoords_RioGeral.concat(polygonCoords_Rio2);
    this.state.polygonCoords_RioGeral = this.state.polygonCoords_RioGeral.concat(polygonCoords_Rio21);
    this.state.polygonCoords_RioGeral = this.state.polygonCoords_RioGeral.concat(polygonCoords_Rio3);
    this.state.polygonCoords_RioGeral = this.state.polygonCoords_RioGeral.concat(polygonCoords_Rio31);

    const locationState = this.props.router?.location?.state || this.props.location?.state;

    if (locationState) {
      await this.setState({ login: locationState.fields.login });
      await this.setState({ option: locationState.fields.option });
      await this.setState({ selected_city: locationState.fields.selected_city });
      await this.setState({ name: locationState.fields.name.split('"').join('') });
      await this.setState({ secretary: locationState.fields.secretary.split('"').join('') });
      await this.setState({ secretary_id: locationState.fields.secretary_id });
      await this.setState({ user_id: locationState.fields.user_id });
    } else {
      const idx = document.URL.indexOf('?');

      var params = [];
      if (idx !== -1) {
        var pairs = document.URL.substring(idx + 1, document.URL.length).split('&');
        //alert(pairs);
        for (var i = 0; i < pairs.length; i++) {
          let nameVal = pairs[i].split(',');
          nameVal = pairs[i].replace('login=', '');
          nameVal = nameVal.replace('option=', '');
          nameVal = nameVal.replace('selected_city=', '');
          nameVal = nameVal.replace('name=', '');
          nameVal = nameVal.replace('secretary=', '');
          nameVal = nameVal.replace('secretary_id=', '');
          nameVal = nameVal.replace('user_id=', '');
          params.push(nameVal);
        }
      }

      await this.setState({ login: decodeURI(params[0]) });
      await this.setState({ option: decodeURI(params[1]) });
      await this.setState({ selected_city: decodeURI(params[2]) });
      await this.setState({ name: decodeURI(params[3]) });
      await this.setState({ secretary: decodeURI(params[4]) });
      await this.setState({ secretary_id: decodeURI(params[5]) });
      await this.setState({ user_id: decodeURI(params[6]) });
    }

    user = this.state.user_id;
    selected_city = this.state.selected_city;

    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.setState({ row: false });
    } else {
      this.setState({ row: true });
    }

    await this.setState({ latitude: -22.931987594567158 });
    await this.setState({ longitude: -43.44911393720455 });

    selected_city = this.state.selected_city;

    try {
      let resp = await api.get('/process', {
        params: {
          secretary_id: this.state.secretary_id,
          selected_city: this.state.selected_city
        }
      });
      if (resp != null) {
        if (resp.data) {
          //alert(JSON.stringify(resp.data));
          if (JSON.stringify(resp.data).includes('protocol')) {
            users = resp.data;

            for (let i = 0; i < resp.data.length; i++) {
              let status = '';
              if (resp.data[i].status === 1) {
                status = '🟡 Pendente';
              } else {
                if (resp.data[i].status === 2) {
                  status = '🟢 Regularizado';
                } else {
                  if (resp.data[i].status === 3) {
                    status = '🔴 Negado';
                  }
                }
              }
              let aux = {
                id: `${resp.data[i].id}`,
                name: `${resp.data[i].process_name}`,
                protocol: `${resp.data[i].protocol}`,
                process: `${resp.data[i].process_number}`,
                secretary: `${resp.data[i].secretary_name}`,
                subcategory: `${resp.data[i].subcategory_name}`,
                city: `${resp.data[i].city} - ${resp.data[i].state}`,
                theme: `${resp.data[i].theme}`,
                subtheme: `${resp.data[i].subtheme}`,
                description: `${resp.data[i].description}` === 'undefined' ? '' : `${resp.data[i].description}`,
                status: status,
                latitude: `${resp.data[i].latitude}`,
                longitude: `${resp.data[i].longitude}`,
              };
              rows = Object.assign([], rows);
              rows.push(aux);
            }

            this.setState({ page_rows: rows });

            this.setState({ places: resp.data });

          } else {
            let msg = JSON.stringify(resp.data);
            console.log(msg)
          }
        }
      }
    } catch (err) {
      console.error(err);
    }

    this.setState({ page_rows: rows });

    this.handleNews();

  }

  handleRegular = async () => {
    try {
      let resp = await api.get('/regularlocations', {
        params: {
          selected_city: this.state.selected_city
        }
      });
      if (resp != null) {
        if (resp.data) {
          if (JSON.stringify(resp.data).includes('name')) {

            await this.setState({ places: resp.data });

          } else {
            await this.setState({ places: resp.data });
          }
        }
      }
    } catch (err) {
      console.error(err);
    }

  }

  handleNegattive = async () => {
    try {
      let resp = await api.get('/negattivelocations', {
        params: {
          selected_city: this.state.selected_city
        }
      });
      if (resp != null) {
        if (resp.data) {
          if (JSON.stringify(resp.data).includes('name')) {

            await this.setState({ places: resp.data });

          } else {
            await this.setState({ places: resp.data });
          }
        }
      }
    } catch (err) {
      console.error(err);
    }

  }

  handlePendence = async () => {
    try {
      let resp = await api.get('/pendencelocations', {
        params: {
          selected_city: this.state.selected_city
        }
      });
      if (resp != null) {
        if (resp.data) {
          if (JSON.stringify(resp.data).includes('name')) {

            await this.setState({ places: resp.data });

          } else {
            await this.setState({ places: resp.data });
          }
        }
      }
    } catch (err) {
      console.error(err);
    }

  }

  handleChangePanel = (panel) => (event, isExpanded) => {
    this.setState({ expanded: isExpanded ? panel : false });
  };

  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      });
    }
    if (this.state.showingInfoWindow2) {
      this.setState({
        showingInfoWindow2: false,
        activeMarker: null
      });
    }
  };

  onMarkerClick = (props, marker) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      showingInfoWindow2: false
    });
  }
  onMarkerClick2 = (props, marker) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow2: true,
      showingInfoWindow: false
    });
  }

  handleChange = async e => {
    await this.setState({ [e.target.name]: e.target.value });
  }

  handleSearch = async (keyword) => {

    try {
      let resp = await api.get('/search', {
        params: {
          keyword,
          type: this.state.expanded,
          secretary_id: this.state.secretary_id,
          selected_city: this.state.selected_city
        }
      });
      if (resp != null) {
        if (resp.data) {
          if (JSON.stringify(resp.data).includes('protocol')) {
            users = resp.data;

            rows = [];

            for (let i = 0; i < resp.data.length; i++) {
              let status = '';
              if (resp.data[i].status === 1) {
                status = '🟡 Pendente';
              } else {
                if (resp.data[i].status === 2) {
                  status = '🟢 Regularizado';
                } else {
                  if (resp.data[i].status === 3) {
                    status = '🔴 Negado';
                  }
                }
              }
              let aux = {
                id: `${resp.data[i].id}`,
                name: `${resp.data[i].process_name}`,
                protocol: `${resp.data[i].protocol}`,
                process: `${resp.data[i].process_number}`,
                secretary: `${resp.data[i].secretary_name}`,
                subcategory: `${resp.data[i].subcategory_name}`,
                city: `${resp.data[i].city} - ${resp.data[i].state}`,
                theme: `${resp.data[i].theme}`,
                subtheme: `${resp.data[i].subtheme}`,
                description: `${resp.data[i].description}` === 'undefined' ? '' : `${resp.data[i].description}`,
                status: status,
                latitude: `${resp.data[i].latitude}`,
                longitude: `${resp.data[i].longitude}`,
              };
              this.setState({ page_rows: Object.assign([], rows) });
              rows = Object.assign([], rows);
              rows.push(aux);
            }

            this.setState({ page_rows: rows });

            this.setState({ places: resp.data });

          } else {
            let msg = JSON.stringify(resp.data);
            console.log(msg)
          }
        }
      }
    } catch (err) {
      console.error(err);
    }

    this.setState({ page_rows: rows });

  }

  handleMarkerFromAddress = async () => {

    await fromAddress(this.state.oneSearch + ' rio de janeiro').then(
      (response) => {
        const { lat, lng } = response.results[0].geometry.location;
        //this.setState({ latitude: lat, longitude: lng });
        //this.setState({ open_error: false });
        //this.setState({ zoom: 19 })
        this.setState({ oneMarker: { lat, lng, name: this.state.oneSearch } });
      },
      (error) => {
        //this.setState({ msg: 'Não foi possível encontrar este endereço.' });
        console.error(error);
      }
    );

  }

  handleNews = async () => {

    this.setState({ iframeUrl: '' });

    try {
      const response = await axios.get('http://servicodados.ibge.gov.br/api/v3/noticias/?tipo=noticia&qtd=4&busca=rio%20de%20janeiro');
      await this.setState({ news: response.data.items });

      for (let i = 0; i < this.state.news.length; i++) {

        let imageStr = JSON.stringify(this.state.news[i].imagens);
        imageStr = imageStr.substring(imageStr.indexOf('images'), imageStr.indexOf('.jpg') + 4); //pegando só a primeira imagem da notícia
        imageStr = imageStr.replace('\\/', '/');
        imageStr = imageStr.replace('\\/', '/');
        imageStr = imageStr.replace('\\/', '/');
        imageStr = imageStr.replace('\\/', '/');
        imageStr = imageStr.replace('\\/', '/');
        imageStr = imageStr.replace('\\/', '/');
        imageStr = imageStr.replace('\\/', '/');
        imageStr = imageStr.replace('\\/', '/');

        this.state.news[i].new_image = imageStr;

      }

      await this.setState({ news: this.state.news });

      //window.open('http://servicodados.ibge.gov.br/api/v3/noticias/?tipo=noticia&qtd=4&busca=rio%20de%20janeiro', '_blank');
    } catch (error) {
      console.error('Erro ao buscar notícias:', error);
    }

  }

  /*handleSchools = async () => {
    this.setState({ schools_2022Data: escolas_2022.features });
  }
  handleMilitaryPolice = async () => {
    this.setState({ militaryPolicesData: batalhoes_policia_militar.features });
  }
  handleFireDepartment = async () => {
    this.setState({ fireDepartmentData: batalhoes_corpo_bombeiros_militares.features });
  }
  handleHealthcare = async () => {
    this.setState({ healthcareData: estabelecimentos_de_saude.features });
  }
  handleWaterTreatment = async () => {
    this.setState({ waterTreatmentData: estacoes_tratamento_agua.features });
  }
  handleReservoirs = async () => {
    this.setState({ reservoirsData: reservatorios.features });
  }
  handleTrain = async () => {
    this.setState({ trainData: estacoes_trem.features });
  }
  handleTrainWays = async () => {
    this.setState({ trainWaysData: trajetos_trem.features });
  }
  handleSpringPreservation = async () => {
    this.setState({ springPreservationData: preservacao_permanente_nascentes.features });
  }
  handleFlashFloodsSusceptibility = async () => {
    this.setState({ flashFloodsSusceptibilityData: suscetibilidade_enxurrada.features });
  }
  handleHealthcarePragmaticAreas = async () => {
    this.setState({ healthcarePragmaticAreasData: areas_pragmaticas_saude.features });
  }
  handleEducationCoordnators = async () => {
    this.setState({ educationCoordnatorsData: coordenadorias_regionais_educacao.features });
  }
  handleProtectedAreas = async () => {
    this.setState({ protectedAreasData: areas_protegidas.features });
  }
  handleJails = async () => {
    this.setState({ jailsData: unidades_prisionais.features });
  }
  handleHydrography = async () => {
    this.setState({ hydrographyData: hidrografia.features });
  }*/

  render() {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        margin: -10,
      }}
      >
        <ThemeProvider theme={theme}>
          <Header
            history={this.props.history}
            login={this.state.login}
            option={this.state.option}
            selected_city={this.state.selected_city}
            name={this.state.name}
            secretary={this.state.secretary}
            secretary_id={this.state.secretary_id}
            user_id={this.state.user_id}
            {...this.props}
          />

          <Box sx={{
            backgroundColor: '#E5E6F0',
          }}
          >

            {this.state.row ? (
              <div style={styles.directionRow}>

                <div style={styles.directionColumn}>
                  <Fab
                    variant="extended"
                    color="primary"
                    aria-label="open"
                    style={{ margin: 7, width: 360 }}
                    onClick={() =>
                      this.setState({ filterView: !this.state.filterView })
                    }
                  >
                    {this.state.filterView ? <Close style={{ marginRight: 10 }} /> : <Assignment style={{ marginRight: 10 }} />}
                    {this.state.filterView ? 'Fechar' : 'Filtro'}
                  </Fab>

                  {this.state.filterView ? (
                    <Box
                      sx={{
                        margin: 10
                      }}
                    >

                      <Typography style={styles.text}>
                        Filtro de requerimentos, processos e senso
                      </Typography>

                      {anotherItems.map((item) =>
                        <Accordion
                          expanded={this.state.expanded === `panel${item}`}
                          onChange={this.handleChangePanel(`panel${item}`)}
                          style={styles.button}
                        //onClick={() => readFile()}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${item}a-content`}
                            id={`panel${item}a-header`}
                          >
                            <Typography>
                              {item}
                            </Typography>
                          </AccordionSummary>

                          <AccordionDetails>

                            <div style={styles.directionColumn}>
                              <div style={styles.directionRow}>
                                <TextField
                                  style={{ margin: 10 }}
                                  id={`keyword${item}`}
                                  name={`keyword${item}`}
                                  label="Buscar requisições"
                                  variant="outlined"
                                />

                                <Button
                                  variant="contained"
                                  color="primary"
                                  style={{ marginTop: 12, marginLeft: 10, height: 50, textTransform: 'none' }}
                                  onClick={() => {
                                    this.setState({ processView: false });
                                    this.handleSearch(document.getElementById('keyword' + item).value);
                                  }}
                                  startIcon={<Search />}
                                >
                                  Buscar
                                </Button>
                              </div>

                              <div style={styles.directionRow}>
                                <TextField
                                  style={{ margin: 10 }}
                                  id="pref"
                                  name="pref"
                                  label="Buscar processos"
                                  variant="outlined"
                                  value={this.state.oneSearch}
                                  onChange={e => this.setState({ oneSearch: e.target.value })}
                                />

                                <Button
                                  variant="contained"
                                  color="primary"
                                  style={{ marginTop: 12, marginLeft: 10, height: 50, textTransform: 'none' }}
                                  onClick={() => {
                                    this.setState({ processView: true });
                                    this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${this.state.oneSearch}` });
                                    this.handleMarkerFromAddress();
                                  }}
                                  startIcon={<Search />}
                                >
                                  Buscar
                                </Button>
                              </div>

                              {item === 'Tema' && (
                                <div style={{ overflow: 'auto', maxHeight: 400 }}>
                                  <Typography style={styles.text3}>
                                    Administrativo
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.adminDocs}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ adminDocs: !this.state.adminDocs });
                                          if (this.state.adminDocs === true) {
                                            await this.setState({ processView: true });
                                            await this.setState({ renderProcess: true });
                                            await this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/administrativo,${this.state.oneSearch}` });
                                            this.setState({ defenseDocs: false });
                                            this.setState({ humanDocs: false });
                                            this.setState({ childDocs: false });
                                            this.setState({ cutureDocs: false });
                                            this.setState({ servicesDocs: false });
                                            this.setState({ newsDocs: false });
                                          } else {
                                            this.setState({ renderProcess: false });
                                            this.setState({ iframeUrl: '' });
                                          }
                                        }}
                                      />
                                    }
                                    label="Processos Administrativos"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Defesa da Cidadania
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.defenseDocs}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ defenseDocs: !this.state.defenseDocs });
                                          if (this.state.defenseDocs === true) {
                                            await this.setState({ processView: true });
                                            await this.setState({ renderProcess: true });
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/defesa%20da%20cidadania,${this.state.oneSearch}` });
                                            this.setState({ adminDocs: false });
                                            this.setState({ humanDocs: false });
                                            this.setState({ childDocs: false });
                                            this.setState({ cutureDocs: false });
                                            this.setState({ servicesDocs: false });
                                            this.setState({ newsDocs: false });
                                          } else {
                                            this.setState({ renderProcess: false });
                                            this.setState({ iframeUrl: '' });
                                          }
                                        }}
                                      />
                                    }
                                    label="Processos de Defesa da Cidadania"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Direitos Humanos
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.humanDocs}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ humanDocs: !this.state.humanDocs });
                                          if (this.state.humanDocs === true) {
                                            await this.setState({ processView: true });
                                            this.setState({ renderProcess: true });
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/direitos%20humanos,${this.state.oneSearch}` });
                                            this.setState({ adminDocs: false });
                                            this.setState({ defenseDocs: false });
                                            this.setState({ childDocs: false });
                                            this.setState({ cutureDocs: false });
                                            this.setState({ servicesDocs: false });
                                            this.setState({ newsDocs: false });
                                          } else {
                                            this.setState({ renderProcess: false });
                                            this.setState({ iframeUrl: '' });
                                          }
                                        }}
                                      />
                                    }
                                    label="Processos de Direitos Humanos"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Infância e Juventude
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.childDocs}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ childDocs: !this.state.childDocs });
                                          if (this.state.childDocs === true) {
                                            await this.setState({ processView: true });
                                            this.setState({ renderProcess: true });
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/infância%20e%20juventude,${this.state.oneSearch}` });
                                            this.setState({ adminDocs: false });
                                            this.setState({ defenseDocs: false });
                                            this.setState({ humanDocs: false });
                                            this.setState({ cutureDocs: false });
                                            this.setState({ servicesDocs: false });
                                            this.setState({ newsDocs: false });
                                          } else {
                                            this.setState({ renderProcess: false });
                                            this.setState({ iframeUrl: '' });
                                          }
                                        }}
                                      />
                                    }
                                    label="Processos de Infância e Juventude"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Patrimônio Cultural
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.cutureDocs}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ cutureDocs: !this.state.cutureDocs });
                                          if (this.state.cutureDocs === true) {
                                            await this.setState({ processView: true });
                                            this.setState({ renderProcess: true });
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/patrimônio%20cultural,${this.state.oneSearch}` });
                                            this.setState({ adminDocs: false });
                                            this.setState({ defenseDocs: false });
                                            this.setState({ humanDocs: false });
                                            this.setState({ childDocs: false });
                                            this.setState({ servicesDocs: false });
                                            this.setState({ newsDocs: false });
                                          } else {
                                            this.setState({ renderProcess: false });
                                            this.setState({ iframeUrl: '' });
                                          }
                                        }}
                                      />
                                    }
                                    label="Processos de Patrimônio Cultural"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Serviços Públicos
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.servicesDocs}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ servicesDocs: !this.state.servicesDocs });
                                          if (this.state.servicesDocs === true) {
                                            await this.setState({ processView: true });
                                            this.setState({ renderProcess: true });
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/serviços%20públicos,${this.state.oneSearch}` });
                                            this.setState({ adminDocs: false });
                                            this.setState({ defenseDocs: false });
                                            this.setState({ humanDocs: false });
                                            this.setState({ childDocs: false });
                                            this.setState({ cutureDocs: false });
                                            this.setState({ newsDocs: false });
                                          } else {
                                            this.setState({ renderProcess: false });
                                            this.setState({ iframeUrl: '' });
                                          }
                                        }}
                                      />
                                    }
                                    label="Processos de Serviços Públicos"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Notícias
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.newsDocs}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ newsDocs: !this.state.newsDocs });
                                          if (this.state.newsDocs === true) {
                                            await this.setState({ processView: true });
                                            this.setState({ renderProcess: true });
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ newsClicked: true });
                                            this.handleNews();
                                            this.setState({ adminDocs: false });
                                            this.setState({ defenseDocs: false });
                                            this.setState({ humanDocs: false });
                                            this.setState({ childDocs: false });
                                            this.setState({ cutureDocs: false });
                                            this.setState({ servicesDocs: false });
                                          } else {
                                            this.setState({ renderProcess: false });
                                            this.setState({ news: [] });
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ newsClicked: false });
                                          }
                                        }}
                                      />
                                    }
                                    label="Lista de Notícias"
                                  />
                                  <Divider />


                                  <Typography style={styles.text3}>
                                    Educação
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.schools}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ schools: !this.state.schools });
                                          if (this.state.schools) {
                                            //this.handleSchools();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/escola,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ schools_2022Data: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Escolas 2022"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.educationCoordnators}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ educationCoordnators: !this.state.educationCoordnators });
                                          if (this.state.educationCoordnators) {
                                            //this.handleEducationCoordnators();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/coordenadoria,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ educationCoordnatorsData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Coordenadorias Regionais de Educação (CRE) - SME-RIO"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Meio Ambiente
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.springPreservation}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ springPreservation: !this.state.springPreservation });
                                          if (this.state.springPreservation) {
                                            //this.handleSpringPreservation();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/preservação,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ springPreservationData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Áreas de Preservação Permanente de Nascentes - INEA"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.protectedAreas}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ protectedAreas: !this.state.protectedAreas });
                                          if (this.state.protectedAreas) {
                                            //this.handleProtectedAreas();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/protegida,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ protectedAreasData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Áreas Protegidas - PCRJ"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.flashFloodsSusceptibility}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ flashFloodsSusceptibility: !this.state.flashFloodsSusceptibility });
                                          if (this.state.flashFloodsSusceptibility) {
                                            //this.handleFlashFloodsSusceptibility();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/enxurrada,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ flashFloodsSusceptibilityData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Suscetibilidade à Enxurrada - CPRM"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Saneamento Básico
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.waterTreatment}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ waterTreatment: !this.state.waterTreatment });
                                          if (this.state.waterTreatment) {
                                            //this.handleWaterTreatment();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/água,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ waterTreatmentData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Estações de Tratamento de Água (ETA)"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.hydrography}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ hydrography: !this.state.hydrography });
                                          if (this.state.hydrography) {
                                            //this.handleHydrography();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/hidrografia,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ hydrographyData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Hidrografia - ERJ"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.reservoirs}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ reservoirs: !this.state.reservoirs });
                                          if (this.state.reservoirs) {
                                            //this.handleReservoirs();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/reservatório,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ reservoirsData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Reservatórios - ERJ"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Segurança Pública
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.militaryPolices}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ militaryPolices: !this.state.militaryPolices });
                                          if (this.state.militaryPolices) {
                                            //this.handleMilitaryPolice();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/polícia%20militar,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ militaryPolicesData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Batalhões da Polícia Militar"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.fireDepartment}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ fireDepartment: !this.state.fireDepartment });
                                          if (this.state.fireDepartment) {
                                            //this.handleFireDepartment();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/bombeiro,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ fireDepartmentData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Batalhões do Corpo de Bombeiros Militares - ERJ"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.jails}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ jails: !this.state.jails });
                                          if (this.state.jails) {
                                            //this.handleJails();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/cadeia,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ jailsData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Unidades Prisionais - ERJ"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Saúde Pública
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.healthcare}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ healthcare: !this.state.healthcare });
                                          if (this.state.healthcare) {
                                            //this.handleHealthcare();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/saúde,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ healthcareData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Estabelecimentos de Saúde"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.healthcarePragmaticAreas}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ healthcarePragmaticAreas: !this.state.healthcarePragmaticAreas });
                                          if (this.state.healthcarePragmaticAreas) {
                                            //this.handleHealthcarePragmaticAreas();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/saúde,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ healthcarePragmaticAreasData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Áreas Pragmáticas de Saúde"
                                  />
                                  <Divider />

                                  <Typography style={styles.text3}>
                                    Transporte Público
                                  </Typography>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.train}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ train: !this.state.train });
                                          if (this.state.train) {
                                            //this.handleTrain();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/transporte,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ trainData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Estações de Trêm - IPP"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        value={this.state.trainWays}
                                        color="primary"
                                        onChange={async () => {
                                          await this.setState({ trainWays: !this.state.trainWays });
                                          if (this.state.trainWays) {
                                            //this.handleTrainWays();
                                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/transporte,${this.state.oneSearch}` });
                                          } else {
                                            this.setState({ iframeUrl: '' });
                                            this.setState({ trainWaysData: [] });
                                          }
                                        }}
                                      />
                                    }
                                    label="Trajetos de Trêm - IPP"
                                  />
                                </div>
                              )}
                            </div>

                          </AccordionDetails>

                        </Accordion>
                      )}

                    </Box>
                  ) : (
                    <Box
                      sx={{
                        margin: 10
                      }}
                    >
                      <div style={{ overflow: 'scroll', maxHeight: '137%', maxWidth: '96%', marginLeft: 5, marginRight: -1300 }}>
                        {this.state.news.map((item) =>
                          <div>
                            <a href={item.link} target="_blank" ref="noreferrer">
                              <Typography style={styles.text3}>
                                {item.titulo.toString().replace('IBGE', 'Rio de Janeiro')}
                              </Typography>
                            </a>
                            <Typography style={styles.text4}>
                              {item.introducao}
                            </Typography>

                            <img src={`https://agenciadenoticias.ibge.gov.br/${item.new_image}`} style={styles.image} />

                            <Divider style={{ margin: 10, marginLeft: -5, height: 2 }} />
                          </div>
                        )}
                      </div>
                    </Box>
                  )}
                </div>

                <Box
                  sx={{
                    width: '45%',
                    height: window.innerHeight,
                    backgroundColor: '#E5E6F0',
                    //marginLeft: '45%',
                  }}
                >

                  <div style={styles.directionRow}>
                    <Typography style={styles.text}>
                      Bem vindo {this.state.name} ({this.state.secretary})
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ height: 25, marginTop: 20, textTransform: 'none' }}
                      startIcon={<Assignment />}
                      onClick={() => {
                        this.setState({ processView: !this.state.processView });
                      }}
                    >
                      {this.state.processView ? 'Requisições' : 'Processos'}
                    </Button>
                  </div>

                  <Container maxWidth="lg" style={{ marginLeft: 15 }}>
                    <TextField
                      style={styles.text2}
                      id="search"
                      name="search"
                      value={this.state.search}
                      label="Buscar localidade"
                      onChange={this.handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />

                    {this.state.processView ? (
                      <Box
                        sx={{
                          width: '100%',
                          height: window.innerHeight - 300,
                          backgroundColor: '#E5E6F0',
                          margin: 10,
                          marginBottom: 10,
                        }}
                      >

                        {this.state.iframeUrl ? (
                          <iframe src={this.state.iframeUrl} title="Processos" style={styles.iframe} />
                        ) : null}

                        {this.state.newsClicked ? (
                          <div style={{ overflow: 'scroll', maxHeight: '137%' }}>
                            {this.state.news.map((item) =>
                              <div>
                                <a href={item.link} target="_blank" ref="noreferrer">
                                  <Typography style={styles.text3}>
                                    {item.titulo.toString().replace('IBGE', 'Rio de Janeiro')}
                                  </Typography>
                                </a>
                                <Typography style={styles.text4}>
                                  {item.introducao}
                                </Typography>

                                <img src={`https://agenciadenoticias.ibge.gov.br/${item.new_image}`} style={styles.image} />

                                <Divider />
                              </div>
                            )}
                          </div>
                        ) : null}

                      </Box>
                    ) : (
                      <DataGrid
                        components={{ Toolbar: GridToolbar }}
                        style={{ height: 500 }}
                        rows={this.state.page_rows}
                        columns={columns}
                        pageSize={7}
                        rowsPerPageOptions={[7]}
                        disableSelectionOnClick
                        localeText={ptBR}
                        onCellClick={async (row) => {
                          rowsArray = [];
                          await rowsArray.push(row);
                          process = '';
                          process = rowsArray[0].row.id;
                          this.setState({ latitude: rowsArray[0].row.latitude });
                          this.setState({ longitude: rowsArray[0].row.longitude });
                          this.setState({ zoom: 17 });
                        }}
                      />
                    )}
                  </Container>

                </Box>

                <Box
                  sx={{
                    backgroundColor: '#E5E6F0',
                  }}
                >

                  <div>
                    <Map
                      key={'AIzaSyCxR8BvJtPbkL9EsQ-j-Fze8DaDTpFlGnk'}
                      google={this.props.google}
                      zoom={this.state.zoom}
                      style={styles.map}
                      mapType="map"
                      center={{
                        lat: this.state.latitude,
                        lng: this.state.longitude
                      }}
                      onClick={this.onMapClicked}
                    >


                      {this.state.polygonCoords_RioGeral && (
                        <Polygon
                          paths={this.state.polygonCoords_RioGeral}
                          strokeColor="#048138"
                          strokeOpacity={0.7}
                          strokeWeight={2}
                          fillColor="#d9be29"
                          fillOpacity={0.1}
                        />
                      )}

                      {/*<Polygon
                        paths={polygonCoords_Barra_da_Tijuca}
                        strokeColor="#800000"
                        strokeOpacity={0.5}
                        strokeWeight={2}
                        fillColor="#fff"
                        fillOpacity={0.2}
                      />*/}

                      {this.state.oneMarker && (

                        <Marker
                          position={{
                            lat: this.state.oneMarker.lat,
                            lng: this.state.oneMarker.lng
                          }}
                          onClick={async (props, marker) => {

                          }}
                          name={this.state.oneMarker.name}
                        />

                      )}

                      {this.state.schools_2022Data.map((item) => {
                        return item.properties.no_municipio === 'Rio De Janeiro' ?
                          <Marker
                            icon={{
                              url: school_icon,
                              scaledSize: new window.google.maps.Size(32, 40)
                            }}
                            position={{
                              lat: item.properties.longitude,
                              lng: item.properties.latitude
                            }}
                            onClick={async (props, marker) => {
                              await this.setState({ process_id: item.properties.objectid });
                              await this.setState({ no_entidade: item.properties.no_entidade });
                              await this.setState({ end_concat: item.properties.end_concat });
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.properties.no_entidade},${''}` });
                              this.onMarkerClick2(props, marker);
                            }}
                            name={item.properties.no_entidade}
                          /> : null
                      }
                      )}

                      {this.state.militaryPolicesData.map((item) => {
                        return item.attributes.municipio.includes('Rio') ?
                          <Marker
                            icon={{
                              url: police_icon,
                              scaledSize: new window.google.maps.Size(32, 32)
                            }}
                            position={{
                              lat: item.geometry.y,
                              lng: item.geometry.x
                            }}
                            onClick={async (props, marker) => {
                              await this.setState({ process_id: item.attributes.objectid });
                              await this.setState({ no_entidade: item.attributes.unidade });
                              await this.setState({ end_concat: item.attributes.endereco });
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.attributes.unidade},${''}` });
                              this.onMarkerClick2(props, marker);
                            }}
                            name={item.attributes.unidade}
                          /> : null
                      }
                      )}

                      {this.state.fireDepartmentData.map((item) => {
                        return item.attributes.municipio.includes('Rio') ?
                          <Marker
                            icon={{
                              url: fire_icon,
                              scaledSize: new window.google.maps.Size(32, 32)
                            }}
                            position={{
                              lat: item.geometry.y,
                              lng: item.geometry.x
                            }}
                            onClick={async (props, marker) => {
                              await this.setState({ process_id: item.attributes.objectid });
                              await this.setState({ no_entidade: item.attributes.corporacao });
                              await this.setState({ end_concat: item.attributes.endereco });
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.attributes.corporacao},${''}` });
                              this.onMarkerClick2(props, marker);
                            }}
                            name={item.attributes.corporacao}
                          /> : null
                      }
                      )}

                      {this.state.jailsData.map((item) => {
                        return item.attributes.municipio.includes('Rio') ?
                          <Marker
                            icon={{
                              url: jails_icon,
                              scaledSize: new window.google.maps.Size(55, 55)
                            }}
                            position={{
                              lat: item.geometry.y,
                              lng: item.geometry.x
                            }}
                            onClick={async (props, marker) => {
                              await this.setState({ process_id: item.attributes.objectid });
                              await this.setState({ no_entidade: item.attributes.unidade });
                              await this.setState({ end_concat: item.attributes.endereco });
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.attributes.unidade},${''}` });
                              this.onMarkerClick2(props, marker);
                            }}
                            name={item.attributes.unidade}
                          /> : null
                      }
                      )}

                      {this.state.healthcareData.map((item) => {
                        return item.properties.ds_municipio.includes('RIO') ?
                          <Marker
                            icon={{
                              url: healthcare_icon,
                              scaledSize: new window.google.maps.Size(32, 32)
                            }}
                            position={{
                              lat: item.properties.nu_latitude_edit,
                              lng: item.properties.nu_longitude_edit
                            }}
                            onClick={async (props, marker) => {
                              await this.setState({ process_id: item.properties.objectid });
                              await this.setState({ no_entidade: item.properties.no_fantasia });
                              await this.setState({ end_concat: item.properties.ds_endereco });
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.properties.no_fantasia},${''}` });
                              this.onMarkerClick2(props, marker);
                            }}
                            name={item.properties.no_fantasia}
                          /> : null
                      }
                      )}

                      {this.state.waterTreatmentData.map((item) => {
                        return item.attributes.nm_mun_low.includes('Rio') ?
                          <Marker
                            icon={{
                              url: water_treatment_icon,
                              scaledSize: new window.google.maps.Size(32, 32)
                            }}
                            position={{
                              lat: item.geometry.y,
                              lng: item.geometry.x
                            }}
                            onClick={async (props, marker) => {
                              await this.setState({ process_id: item.attributes.objectid });
                              await this.setState({ no_entidade: item.attributes.aoaa38 });
                              await this.setState({ end_concat: item.attributes.regiao_erj });
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.attributes.aoaa38},${''}` });
                              this.onMarkerClick2(props, marker);
                            }}
                            name={item.attributes.aoaa38}
                          /> : null
                      }
                      )}

                      {this.state.reservoirsData.map((item) => {
                        return item.attributes.nm_mun_low.includes('Rio') ?
                          <Marker
                            icon={{
                              url: reservoirs_icon,
                              scaledSize: new window.google.maps.Size(32, 32)
                            }}
                            position={{
                              lat: item.geometry.y,
                              lng: item.geometry.x
                            }}
                            onClick={async (props, marker) => {
                              await this.setState({ process_id: item.attributes.objectid });
                              await this.setState({ no_entidade: item.attributes.aoaa54_58 });
                              await this.setState({ end_concat: item.attributes.regiao_erj });
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.attributes.aoaa54_58},${''}` });
                              this.onMarkerClick2(props, marker);
                            }}
                            name={item.attributes.aoaa54_58}
                          /> : null
                      }
                      )}

                      {this.state.trainData.map((item) => {
                        return item.attributes.municipio.includes('Rio') ?
                          <Marker
                            icon={{
                              url: train_icon,
                              scaledSize: new window.google.maps.Size(32, 32)
                            }}
                            position={{
                              lat: item.geometry.y,
                              lng: item.geometry.x
                            }}
                            onClick={async (props, marker) => {
                              await this.setState({ process_id: item.attributes.objectid });
                              await this.setState({ no_entidade: item.attributes.nome });
                              await this.setState({ end_concat: item.attributes.ramal + ', ' + item.attributes.bairro + ' - ' + item.attributes.municipio });
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.attributes.nome},${''}` });
                              this.onMarkerClick2(props, marker);
                            }}
                            name={item.attributes.nome}
                          /> : null
                      }
                      )}

                      {this.state.trainWaysData.map((item) =>
                        <Polygon
                          paths={item.geometry.paths}
                          strokeColor="#800"
                          strokeOpacity={0.7}
                          strokeWeight={2}
                          fillColor="#d9be29"
                          fillOpacity={0}
                        />
                      )}

                      {this.state.hydrographyData.map((item) => {
                        return item.attributes.nm_mun_upp === 'RIO DE JANEIRO' ?
                          <Polygon
                            paths={item.geometry.paths}
                            strokeColor="#00a8ff"
                            strokeOpacity={0.7}
                            strokeWeight={2}
                            fillColor="#d9be29"
                            fillOpacity={0}
                          /> : null
                      }
                      )}

                      {this.state.springPreservationData.map((item) => {
                        return item.attributes.nm_mun_upp === 'RIO DE JANEIRO' ?
                          <Polygon
                            paths={item.geometry.rings}
                            strokeColor="#4200a2"
                            strokeOpacity={0.7}
                            strokeWeight={2}
                            fillColor="#4200a2"
                            fillOpacity={0.1}
                          /> : null
                      }
                      )}

                      {this.state.flashFloodsSusceptibilityData.map((item) => {
                        return item.attributes.nm_mun_upp === 'RIO DE JANEIRO' ?
                          <Polygon
                            paths={item.geometry.rings}
                            strokeColor="#120a8f"
                            strokeOpacity={0.7}
                            strokeWeight={2}
                            fillColor="#120a8f"
                            fillOpacity={0.1}
                            onClick={async (props, polygon) => {
                              await this.setState({ process_id: item.attributes.objectid });
                              await this.setState({ no_entidade: item.attributes.distrito });
                              await this.setState({ end_concat: item.attributes.distrito + ', ' + item.attributes.regiao_ibge + ' - ' + item.attributes.nm_mun_upp });
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.attributes.distrito},${''}` });
                              this.onMarkerClick2(props, polygon);
                            }}
                          /> : null
                      }
                      )}

                      {this.state.healthcarePragmaticAreasData.map((item) =>
                        <Polygon
                          paths={item.geometry.coordinates}
                          strokeColor="#808080"
                          strokeOpacity={0.7}
                          strokeWeight={2}
                          fillColor="#808080"
                          fillOpacity={0.1}
                          onClick={async (props, polygon) => {
                            await this.setState({ process_id: item.id }); //não tem informações além de id e polígono
                            //await this.setState({ no_entidade: item.attributes.distrito });
                            //await this.setState({ end_concat: item.attributes.distrito + ', ' + item.attributes.regiao_ibge + ' - ' + item.attributes.nm_mun_upp });
                            //this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.attributes.distrito},${''}` });
                            //this.onMarkerClick2(props, polygon);
                          }}
                        />
                      )}

                      {this.state.educationCoordnatorsData.map((item) => {
                        return item.attributes.nm_mun_upp.includes('Rio') ?
                          <Polygon
                            paths={item.geometry.rings}
                            strokeColor="#54fdaf"
                            strokeOpacity={0.7}
                            strokeWeight={2}
                            fillColor="#54fdaf"
                            fillOpacity={0.1}
                            onClick={async (props, polygon) => {
                              await this.setState({ process_id: item.attributes.objectid });
                              await this.setState({ no_entidade: item.attributes.cre });
                              await this.setState({ end_concat: item.attributes.distrito + ', ' + item.attributes.nm_mun_upp });
                              this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.attributes.cre},${''}` });
                              this.onMarkerClick2(props, polygon);
                            }}
                          /> : null
                      }
                      )}

                      {/*this.state.protectedAreasData.map((item) =>
                        <Polygon
                          paths={item.geometry.rings}
                          strokeColor="#a79d4a"
                          strokeOpacity={0.7}
                          strokeWeight={2}
                          fillColor="#a79d4a"
                          fillOpacity={0.1}
                          onClick={async (props, polygon) => {
                            await this.setState({ process_id: item.attributes.objectid });
                            await this.setState({ no_entidade: item.attributes.uc });
                            await this.setState({ end_concat: item.attributes.obs });
                            this.setState({ iframeUrl: `${apiMunicipios}/readfilerj/${item.attributes.uc},${''}` });
                            this.onMarkerClick2(props, polygon);
                          }}
                        />
                      ) tentar*/}

                      {this.state.places.map((item) =>
                        <Marker
                          icon={{
                            url: (item.status === 1) ? yellow_marker : (item.status === 2) ? green_marker : red_marker,
                            scaledSize: new window.google.maps.Size(32, 40)
                          }}
                          position={{
                            lat: item.latitude,
                            lng: item.longitude
                          }}
                          onClick={async (props, marker) => {
                            this.setState({ process_id: item.id });
                            this.setState({ protocol: item.protocol });
                            this.setState({ subcategory: item.subcategory_name });
                            this.setState({ street: item.street });
                            this.setState({ number: item.number });
                            this.setState({ district: item.district });
                            this.setState({ city: item.city });
                            this.setState({ state: item.state });
                            this.setState({ new_lat: item.latitude });
                            this.setState({ new_lng: item.longitude });
                            this.onMarkerClick(props, marker);
                          }}
                          name={item.name}
                        />
                      )}

                      {this.state.renderProcess &&
                        <Marker
                          position={{
                            lat: -22.932434708068484,
                            lng: -42.49680072989684
                          }}
                          onClick={async (props, marker) => {

                          }}
                          name='Processos em Rio de Janeiro'
                        />
                      }

                      <InfoWindow
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                      >

                        <a
                          href={`${apiString}/process?process_id=${this.state.process_id}&user=${this.state.user_id}&selected_city=${this.state.selected_city}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Button
                            fullWidth
                            variant="text"
                            color="primary"
                            style={{ textTransform: 'none' }}
                          >
                            <Typography variant="h6" color="primary" align="left" style={{ maxWidth: 250 }}>
                              {`${this.state.protocol}`}
                            </Typography>
                          </Button>
                        </a>
                        <Typography variant="subtitle1" color="textSecondary" align="left" style={{ maxWidth: 250 }}>
                          {`${this.state.subcategory}`}
                        </Typography>
                        <Typography variant="subtitle1" color="textSecondary" align="left" style={{ maxWidth: 250 }}>
                          {`${this.state.street}, ${this.state.number} - ${this.state.district}, ${this.state.city} - ${this.state.state}`}
                        </Typography>

                      </InfoWindow>

                      <InfoWindow
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow2}
                      >

                        <Typography variant="h6" color="textSecondary" align="left" style={{ maxWidth: 250 }}>
                          {`${this.state.no_entidade ? this.state.no_entidade : ''}`}
                        </Typography>
                        <Typography variant="subtitle1" color="textSecondary" align="left" style={{ maxWidth: 250 }}>
                          {`${this.state.end_concat ? 'Endereço: ' + this.state.end_concat : ''}`}
                        </Typography>

                      </InfoWindow>

                    </Map>
                  </div>

                </Box>

              </div>
            ) : (
              <div style={styles.directionColumn}>

                <Box
                  style={{
                    width: window.innerWidth - 30,
                    height: window.innerHeight - 370,
                    backgroundColor: '#E5E6F0',
                    marginTop: 10,
                  }}
                >

                  <Map
                    key={'AIzaSyCxR8BvJtPbkL9EsQ-j-Fze8DaDTpFlGnk'}
                    google={this.props.google}
                    zoom={this.state.mobilezoom}
                    style={styles.map2}
                    mapType="map"
                    center={{
                      lat: this.state.latitude,
                      lng: this.state.longitude
                    }}
                    onClick={this.onMapClicked}
                  >


                    {<Polygon
                      paths={polygonCoords_Rio}
                      strokeColor="#d9be29"
                      strokeOpacity={0.5}
                      strokeWeight={2}
                      fillColor="#d9be29"
                      fillOpacity={0.2}
                    />}

                    {/*<Polygon
                      paths={polygonCoords_Barra_da_Tijuca}
                      strokeColor="#800000"
                      strokeOpacity={0.5}
                      strokeWeight={2}
                      fillColor="#fff"
                      fillOpacity={0.2}
                    />*/}

                    {this.state.places.map((item) =>
                      <Marker
                        icon={{
                          url: (item.status === 1) ? yellow_marker : (item.status === 2) ? green_marker : red_marker,
                          scaledSize: new window.google.maps.Size(32, 40)
                        }}
                        position={{
                          lat: item.latitude,
                          lng: item.longitude
                        }}
                        onClick={async (props, marker) => {
                          this.setState({ protocol: item.protocol });
                          this.setState({ subcategory: item.subcategory_name });
                          this.setState({ street: item.street });
                          this.setState({ number: item.number });
                          this.setState({ district: item.district });
                          this.setState({ city: item.city });
                          this.setState({ state: item.state });
                          this.setState({ new_lat: item.latitude });
                          this.setState({ new_lng: item.longitude });
                          this.onMarkerClick(props, marker);
                        }}
                        name={item.name}
                      />
                    )}

                    <InfoWindow
                      marker={this.state.activeMarker}
                      visible={this.state.showingInfoWindow}
                    >

                      <a href={`${apiString}/process?process_id=${this.state.process_id}`} target="_blank" rel="noreferrer">
                        <Button
                          fullWidth
                          variant="text"
                          color="primary"
                          style={{ textTransform: 'none' }}
                        >
                          <Typography variant="h6" color="primary" align="left" style={{ maxWidth: 250 }}>
                            {`${this.state.protocol}`}
                          </Typography>
                        </Button>
                      </a>
                      <Typography variant="subtitle1" color="textSecondary" align="left" style={{ maxWidth: 250 }}>
                        {`${this.state.subcategory}`}
                      </Typography>
                      <Typography variant="subtitle1" color="textSecondary" align="left" style={{ maxWidth: 250 }}>
                        {`${this.state.street}, ${this.state.number} - ${this.state.district}, ${this.state.city} - ${this.state.state}`}
                      </Typography>

                    </InfoWindow>

                  </Map>
                </Box>

                <Box
                  style={{
                    width: window.innerWidth - 30,
                    height: window.innerHeight + 150,
                    backgroundColor: '#E5E6F0',
                  }}
                >

                  <Typography style={styles.text}>
                    Bem vindo {this.state.name} ({this.state.secretary})
                  </Typography>

                  <Container maxWidth="lg" style={{ marginLeft: 15 }}>
                    <TextField
                      style={styles.text2}
                      id="search"
                      name="search"
                      value={this.state.search}
                      label="Buscar localidade"
                      onChange={this.handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                    />

                    <DataGrid
                      components={{ Toolbar: GridToolbar }}
                      style={{ height: 500 }}
                      rows={this.state.page_rows}
                      columns={columns}
                      pageSize={7}
                      rowsPerPageOptions={[7]}
                      disableSelectionOnClick
                      localeText={ptBR}
                      onCellClick={async (row) => {
                        await rowsArray.push(row);
                        process = rowsArray[0].row.process;
                        selected_city = rowsArray[0].row.address;
                      }}
                    />
                  </Container>

                </Box>

              </div>
            )}

          </Box>

          <FooterHome />

        </ThemeProvider>

      </div>
    );
  }
}

export default withRouter(GoogleApiWrapper({
  apiKey: 'AIzaSyCxR8BvJtPbkL9EsQ-j-Fze8DaDTpFlGnk',
  language: 'pt-BR'
})(HomeRio))

let styles = {
  html: {
    backgroundColor: '#E5E6F0',
    margin: -8
  },

  directionRow: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 10,
  },

  directionColumn: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
  },

  text: {
    margin: 20,
    color: '#323232'
  },

  text2: {
    width: '100%',
    marginBottom: 20,
    color: '#323232'
  },

  text3: {
    margin: 5,
    fontSize: 14,
    color: '#048138'
  },

  text4: {
    margin: 5,
    fontSize: 12,
    color: '#323232'
  },

  accordionDiv: {
    marginTop: 10,
  },

  accordion: {
    width: 350,
    backgroundColor: '#048138',
  },

  list: {
    backgroundColor: '#343434',
    width: 315,
  },

  map: {
    width: '33%',
    height: '70%',
    marginLeft: 10,
    marginTop: 10,
    alignSelf: 'flex-start',
  },

  map2: {
    width: '95%',
    height: '50%',
    marginLeft: 12,
  },

  bt2: {
    margin: 10,
    width: '96.7%',
    textTransform: 'none',
    backgroundColor: '#343434',
    color: '#fff'
  },

  examples: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#E5E6F0',
    margin: 10,
    marginTop: 30,
  },

  href: {
    margin: 10,
    color: '#fff'
  },

  avatar: {
    alignSelf: 'center',
    width: 370,
    height: 80,
    margin: 10,
  },

  button: {
    marginLeft: -2,
    borderTop: '1px solid rgba(254, 222, 90, 1)',
    borderBottom: '1px solid rgba(254, 222, 90, 1)',
    width: 360,
    //backgroundColor: '#bfcadb',
  },

  iframe: {
    borderWidth: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#777777',
  },

  image: {
    width: 300,
    height: 200,
  },

};